
export const CALC_KIND_BADGE_COLORS = {
  TIME_RANGE: "blue",
  DAY_KIND: "green",
  ROUTE_ORIGIN: "orange",
  ROUTE_DESTINATION: "teal",
  ROUTE_PASSES_THROUGH: "purple",
  EXEMPTION: "gray",
};

export function humanizeName(value) {
  if (!value) return "";

  return String(value)
    .toLowerCase()
    .replace(/[_-]+/g, " ")          // _ y - → espacio
    .replace(/\s+/g, " ")            // espacios dobles
    .trim()
    .replace(/^\w/, (c) => c.toUpperCase()); // Primera letra mayúscula
}
